export default __webpack_public_path__ + "static/media/bestaicourses.831d385a.png";